<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="users"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white min-height ml-3 pt-3">

            <el-form class="search-form" label-width="90px"
                     label-position="right">
              <el-form-item label="搜索条件">
                <el-input placeholder="请输入内容" v-model="form.query" class="input-with-select">
                  <el-select v-model="form.query_field" slot="prepend" placeholder="请选择" style="width: 100px;"
                             class="mobile-hidden">
                    <el-option label="Email" value="email"></el-option>
                    <el-option label="用户名" value="name"></el-option>
                    <el-option label="真实名" value="realName"></el-option>
                    <el-option label="手机号" value="phone"></el-option>
                  </el-select>
                </el-input>
                <el-button class="ml-2" type="primary" @click="getUsers">查看结果</el-button>
                <el-button @click="btn_cancel">重置选项</el-button>
              </el-form-item>
              <el-form-item label="角色">
                <el-select v-model="form.role" placeholder="请选择角色" class="item_w" clearable
                           v-on:change="role_change($event,'birth')">
                  <el-option v-for="item in roles" :key="item.id" :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
                <label class="item_label">用户组</label>
                <el-select v-model="form.groupId" placeholder="请选择用户组" class="item_w" clearable
                           v-on:change="groupChange($event,'birth')">
                  <el-option v-for="item in groups" :key="item.id" :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button-group>
                  <el-button type="" icon="el-icon-edit" @click="add_group">添加组</el-button>
                  <el-button type="" icon="el-icon-plus" @click="add_user">添加用户</el-button>
                  <el-button type="" icon="el-icon-delete" @click="batchRemove">删除用户</el-button>
                </el-button-group>
              </el-form-item>
            </el-form>


            <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange"
                           :page-size="page.size" :current-page="page.index+1" :total="page.total"
                           style="float:right;">
            </el-pagination>
            <el-table stripe :data="users" border highlight-current v-loading="listLoading"
                      @selection-change="selsChange">
              <el-table-column type="selection"></el-table-column>
              <el-table-column prop="name" label="用户名"></el-table-column>
              <el-table-column prop="realName" label="真实名"></el-table-column>
              <el-table-column prop="email" label="Email"></el-table-column>
              <el-table-column prop="inviteBy" label="推荐人"></el-table-column>
              <el-table-column prop="lastLogin" label="最近登录时间" width="155px">
                <template slot-scope="scope">
                  {{ scope.row.lastLogin | formatDateTime }}
                </template>
              </el-table-column>
              <el-table-column prop="deadline" label="账户过期" width="155px">
                <template slot-scope="scope">
                  {{ scope.row.deadline | formatDateTime }}
                </template>
              </el-table-column>
              <el-table-column prop="active" label="禁用" width="60px">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.active=='1'" circle type="info">
                  </el-button>
                  <el-button v-if="scope.row.active==null || scope.row.active==0" circle
                             type="primary">
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column label="角色">
                <template slot-scope="scope">
                  <div v-for="role in scope.row.roles">
                    {{ role }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100px">
                <template slot-scope="scope">
                  <el-dropdown trigger="click" @command="update_scale">
                            <span class="el-dropdown-link">
                              操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :command="before_update_scale('resetPwd',scope.row)">重置密码
                      </el-dropdown-item>
                      <el-dropdown-item :command="before_update_scale('edit',scope.row)">编辑用户
                      </el-dropdown-item>
                      <el-dropdown-item :command="before_update_scale('userAction',scope.row)">查看用户操作
                      </el-dropdown-item>
                      <el-dropdown-item :command="before_update_scale('charge',scope.row)">给用户充值
                      </el-dropdown-item>
                      <el-dropdown-item :command="before_update_scale('activeUser',scope.row)">启用/停用
                      </el-dropdown-item>
                      <el-dropdown-item :command="before_update_scale('requireLogin',scope.row)">踢出
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog :title="formTitle" :visible.sync="dlg_add_user" :close-on-click-modal="false" width="800px">
      <el-form ref="userForm" :model="userForm" :rules="rules" label-width="80px">
        <el-form-item label="登录名" prop="name">
          <el-input v-model="userForm.name" class="item_form"></el-input>
          <label class="item_label">余额</label>
          <el-input v-model="userForm.remain" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="id">
          <el-input v-model="userForm.id" auto-complete="off" class="item_form"></el-input>
          <label class="item_label">groupId</label>
          <el-input v-model="userForm.groupId" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="电话">
          <el-input v-model="userForm.phone" auto-complete="off" class="item_form"></el-input>
          <label class="item_label">邮箱</label>
          <el-input v-model="userForm.email" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="邀请码">
          <el-input v-model="userForm.invite" auto-complete="off" class="item_form"
                    aria-placeholder="具备邀请资格"></el-input>
        </el-form-item>
        <el-form-item label="所属团队" prop="groupId">
          <el-select v-model="userForm.groupId" placeholder="请选择" class="item_form">
            <el-option v-for="item in groups" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <label class="item_label">角色</label>
          <el-select v-model="userForm.roles" multiple placeholder="请选择" class="item_form">
            <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="userForm.realName" auto-complete="off" class="item_form"></el-input>
          <label class="item_label">身份证号</label>
          <el-input v-model="userForm.idCard" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker v-model="userForm.birthDay"
                          type="date"
                          placeholder="选择日期"
                          class="item_form">
          </el-date-picker>
          <label class="item_label">性别</label>
          <el-radio-group v-model="userForm.gender" clearable class="item_form">
            <el-radio label="male">男性</el-radio>
            <el-radio label="female">女性</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生地区">
          <el-select v-model="userForm.birthProv" placeholder="请选择省份" clearable class="item_form"
                     v-on:change="getProv($event)">
            <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label class="item_label">出生城市</label>
          <el-select v-model="userForm.birthCity" placeholder="请选择城市" clearable class="item_form">
            <el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="毕业学校">
          <el-input v-model="userForm.school" class="item_form"></el-input>
          <label class="item_label">学历</label>
          <el-input v-model="userForm.degree" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="居住地">
          <el-input v-model="userForm.address" style="width:480px;"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="userForm.friend" class="item_form"></el-input>
          <label class="item_label">联系人电话</label>
          <el-input v-model="userForm.friendPhone" auto-complete="off" class="item_form"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="userForm.remark" :rows="6" style="width:608px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="btn_add_user" type="primary">立即添加</el-button>
          <el-button @click="dlg_add_user=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="添加团队" :visible.sync="dlg_add_group" :close-on-click-modal="false" width="750px">
      <el-form label-width="100px" ref="groupForm" :rules="rules" :model="groupForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="groupForm.name" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="全称">
          <el-input v-model="groupForm.fullName" style="width:500px"></el-input>
        </el-form-item>
        <el-form-item label="团队ID">
          <el-input v-model="groupForm.id" style="width:200px"></el-input>
          <label style="width: 93px;padding-left: 20px;">管理员ID</label>
          <el-input v-model="groupForm.adminId" style="width:200px"></el-input>
        </el-form-item>
        <el-form-item label="appid">
          <el-input v-model="groupForm.appid" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="secret">
          <el-input v-model="groupForm.secret" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="模块">
          <el-checkbox-group v-model="groupForm.moduleList">
            <el-checkbox v-for="item in modules" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="省份">
          <el-select v-model="groupForm.province" placeholder="请选择省份" v-on:change="getProv($event)">
            <el-option v-for="item in provs" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label style="width: 80px;padding-left: 40px;">城市</label>
          <el-select v-model="groupForm.city" placeholder="请选择城市" @click="alert()"
                     v-on:change="getCity($event)">
            <el-option v-for="item in citys" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="地址">
          <el-input v-model="groupForm.address" style="width:500px"></el-input>
        </el-form-item>
        <el-form-item label="邮编">
          <el-input v-model="groupForm.post_code" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contact">
          <el-input v-model="groupForm.contact" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱">
          <el-input v-model="groupForm.email" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="联系人电话">
          <el-input v-model="groupForm.phone" style="width:300px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="clk_add_group" :loading="addLoading" type="primary">提交</el-button>
          <el-button @click.native="dlg_add_group = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="用户操作记录" :visible.sync="dlg_userAction" :close-on-click-modal="false" width="750px">

    </el-dialog>

    <el-dialog title="充值" :visible.sync="dlg_charge" :close-on-click-modal="false" width="450px">
      <el-form label-width="80px">
        <el-form-item label="remain">
          <el-input v-model="balance.remain" disabled></el-input>
        </el-form-item>
        <el-form-item label="total">
          <el-input v-model="balance.total" disabled></el-input>
        </el-form-item>
        <el-form-item label="trial">
          <el-input v-model="balance.trial" disabled></el-input>
        </el-form-item>
        <el-form-item label="trialTotal">
          <el-input v-model="balance.trialTotal" disabled></el-input>
        </el-form-item>
        <el-form-item label="userName">
          <el-input v-model="balance.userName" disabled></el-input>
        </el-form-item>
        <el-form-item label="添加">
          <el-input v-model="balance.addition"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click.native="clk_charge" :loading="addLoading" type="primary">确定</el-button>
          <el-button @click.native="dlg_charge = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/rest'
import util from '../../api/util'
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  name: 'tables',
  components: {HomeSidebar},
  data() {
    return {
      search_key: "",
      groups: [],
      form: {
        query_field: 'name',
      },
      balance: {},
      // 新增界面数据
      userForm: {
        name: '',
        phone: '',
        department: '',
        painpwd: '',
        password: '',
        email: '',
        groupId: '',
        deadline: '',
        maximumCall: '',
        roles: [],
      },
      groupForm: {
        isvalid: true,
        moduleList: ['hr', 'crm'],
      },
      users: [],
      page: {
        total: 0,
        index: 0,
        size: 20
      },
      rules: util.setting.getRules(),
      provs: util.setting.getProvs(),
      citys: [],
      roles: [],
      modules: util.setting.getModules(),
      yearList: util.setting.getYearList(),
      monthList: util.setting.getMonthList(),
      formTitle: '',
      listLoading: false,
      sels: [], // 列表选中列
      editFormVisible: false, // 编辑界面是否显示
      editLoading: false,
      addLoading: false,
      panel_loading: false,
      dlg_add_user: false,
      dlg_add_group: false,
      dlg_charge: false,
      dlg_userAction: false,
      isActive: -1,
      collapse: api.storage.get('isCollapse'),
    }
  },
  methods: {
    btn_cancel() {
      this.form = {
        query_field: 'name',
      }
    },
    validatePass(rule, value, callback) {
      if (this.userForm.password !== '') {
        this.$refs.userForm.validateField('password')
      } else {
        callback()
      }
    },
    validatePass2(rule, value, callback) {
      if (value !== this.userForm.painpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    handleCurrentChange(val) {
      this.page.index = val - 1
      this.getUsers()
    },
    before_update_scale(cmd, item) {
      return {
        "cmd": cmd,
        "item": item
      }
    },
    update_scale(args) {
      if (args['cmd'] === 'resetPwd') {
        this.resetPwd(args['item'])
      } else if (args['cmd'] === 'edit') {
        this.handleEdit(args['item'])
      } else if (args['cmd'] === 'charge') {
        this.handleCharge(args['item'])
      } else if (args['cmd'] === 'userAction') {
        this.userAction(args['item'])
      } else if (args['cmd'] === 'activeUser') {
        this.activeUser(args['item'])
      } else if (args['cmd'] === 'requireLogin') {
        this.requireLogin(args['item'])
      }
    },
    btn_add_user() {
      let api_url = '/user/add'
      let para = this.userForm
      console.log(para)
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status,
        });
        this.getUsers()
        this.dlg_add_user = false;
      }).catch((res) => {
        api.handError.action(this, res);
      });
    },
    // 获取用户组列表
    getRoles() {
      this.listLoading = true
      api.admin.roleList(this.page.index, this.page.size).then((res) => {
        this.roles = res.content
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    role_change(e, args) {
      this.getUsers()
    },
    groupChange(value, index) {
      this.getUsers()
    },
    fillGroup() {
      this.panel_loading = true
      api.admin.groupList(this.page.index, this.page.size).then((res) => {
        this.groups = res.content
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    // 获取用户列表
    getUsers() {
      // name: this.filters.name
      this.listLoading = true
      let data = {
        ...this.page,
        ...this.form
      }
      let api_url = "/sys/listUser"
      if (this.form.groupId != null) {
        api_url = "/user/getUserByGroupId"
        data.groupId = this.form.groupId
      } else if (this.form.role != null) {
        api_url = "/user/getUserByRole"
        data = {
          ...this.page
        }
        data.roleId = this.form.role
      }
      api.remote.doPost(data, api_url).then((res) => {
        this.page.total = res.totalElements
        this.users = res.content
        this.listLoading = false
      }).catch((res) => {
        this.listLoading = false
        api.handError.action(this, res)
      })
    },
    // 踢出用户
    requireLogin: function (row) {
      let data = row
      let api_url = '/user/require_login'
      api.remote.doPost(data, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    // 启用／停用用户
    activeUser: function (row) {
      let data = row
      let enabled = data.active == 0
      if (enabled === true) {
        data.active = 1
      } else {
        data.active = 0
      }
      api.admin.enabledUser(data).then((res) => {
        if (enabled === true) {
          data.active = 0
        } else {
          data.active = 1
        }
      }).catch((res) => {
        api.handError.action(this, res)
      })
    },
    add_user() {
      this.dlg_add_user = true;
      this.formTitle = "添加用户"
    },
    // 新增用户
    clk_add_user: function () {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let para = Object.assign({}, this.userForm)
          // console.log(para)
          let api_url = ''
          if (para.id == undefined) {
            api_url = '/user/add'
          } else {
            api_url = '/user/updateUser'
          }
          api.remote.doPost(para, api_url).then((res) => {
            this.addLoading = false
            this.$message({
              title: res.title,
              message: res.message,
              type: res.status
            })
            this.dlg_add_user = false
            this.getUsers()
          }).catch((res) => {
            this.addLoading = false
            api.handError.action(this, res)
          })
        }
      })
    },
    add_group(row) {
      this.groupForm.contact = row.name
      this.dlg_add_group = true
    },
    // 新增团队
    clk_add_group() {
      this.$refs.groupForm.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let para = Object.assign({}, this.groupForm)
          api.admin.groupAdd(para).then((res) => {
            this.addLoading = false
            this.$message({
              title: res.title,
              message: res.message,
              type: res.status
            })
            this.dlg_add_group = false
          }).catch((res) => {
            this.addLoading = false
            api.handError.action(this, res)
          })
        }
      })
    },
    // 编辑
    handleEditGroup: function (index, row) {
      this.dlg_add_group = true
      this.formTitle = "编辑团队"
      this.groupForm = Object.assign({}, row)
    },
    // 编辑
    handleEdit: function (row) {
      this.dlg_add_user = true
      var userEdit = row
      this.formTitle = "编辑用户"
      this.userForm = Object.assign({}, userEdit)
    },
    userAction: function (row) {

      this.dlg_userAction = true
    },
    handleCharge: function (row) {
      this.balance = {}
      let api_url = '/balance/check'
      let para = {}
      para.userId = row.id
      api.remote.doPost(para, api_url).then((res) => {
        if (res.status == "error") {
          this.$message({
            message: res.message,
            type: res.status,
          });
          return
        }
        this.balance = res
        this.dlg_charge = true
      })
    },
    clk_charge() {
      let api_url = '/balance/set'
      let para = {}
      para.userId = this.balance.userId;
      para.addition = this.balance.addition;
      api.remote.doPost(para, api_url).then((res) => {
        this.$message({
          message: res.message,
          type: res.status,
        });
        item.status = res.message
      })
    },
    // 批量删除
    batchRemove: function () {
      if (this.sels.length === 0) {
        this.$message({
          title: '请选择',
          message: '请选择',
          type: 'msg'
        })
        return
      }
      var models = this.sels.map(item => item)
      this.$confirm('你确定要删除选中的记录？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = models
        api.admin.delAdmin(para).then((res) => {
          this.listLoading = false
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getUsers()
        }).catch((res) => {
          api.handError.action(this, res)
        })
      })
    },
    resetPwd: function (row) {
      this.$confirm('确认重置该用户的密码？', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = row
        api.admin.resetPwd(para).then((res) => {
          this.listLoading = false
          this.$message({
            title: res.title,
            message: res.message,
            type: res.status
          })
          this.getUsers()
        }).catch((res) => {
          this.listLoading = false
          api.handError.action(this, res)
        })
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    }
  },
  filters: {
    formatDateTime(time) {
      var date = new Date(time)
      return date.toLocaleString()
    }
  },
  mounted() {
    // this.$router.push({ path: '/login' })
    this.getUsers()
    this.fillGroup()
    this.getRoles()
  }
}
</script>




// WEBPACK FOOTER //
// Users.vue?754ee308